var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuddenBraking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.50013 10.7333C0.50013 16.385 5.08175 20.9667 10.7335 20.9667C16.3852 20.9667 20.9668 16.385 20.9668 10.7333C20.9668 5.08162 16.3852 0.5 10.7335 0.5C5.08175 0.5 0.50013 5.08162 0.50013 10.7333Z",
    fill: "#2296F2",
    stroke: "#2A2D34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07628 5.66667C7.32927 4.41004 8.07176 3 8.07176 3H14.0444C14.0444 3 14.7869 4.41004 15.0399 5.66667M6.08083 9.66667H5.4172C4.84023 8.13251 4.88203 7.28319 5.4172 5.66667H7.40809L8.40354 6.66667H13.7126L14.7081 5.66667H16.699C17.222 7.2637 17.2545 8.1475 16.699 9.66667H16.0353M6.08083 9.66667V11H8.07173V9.66667M6.08083 9.66667H8.07173M8.07173 9.66667H14.0444M16.0353 9.66667V11H14.0444V9.66667M16.0353 9.66667H14.0444",
    stroke: "#2A2D34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08203 7.33301V8.33301C6.08203 8.33301 7.29544 8.33301 8.07293 8.33301L7.07765 7.33301M16.0365 7.33301V8.33301H14.0456L15.0411 7.33301",
    stroke: "#2A2D34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 8.5H12.3852",
    stroke: "#2A2D34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7234 5.99984L12.0552 5.33317L13.7143 4.6665M9.73242 5.99984L10.0642 5.33317L11.7233 4.6665",
    stroke: "#2A2D34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5C7.00019 12.5 5 12.8 5 14C5 15.5 9 15.5 9 17.5C9 18.9422 7.50075 19.0001 6.50075 19.5001",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5C7.00019 12.5 5 12.8 5 14C5 15.5 9 15.5 9 17.5C9 18.9422 7.50075 19.0001 6.50075 19.5001",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5C7.00019 12.5 5 12.8 5 14C5 15.5 9 15.5 9 17.5C9 18.9422 7.50075 19.0001 6.50075 19.5001",
    stroke: "#2A2D34"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5C15.0002 12.5 13 12.8 13 14C13 15.5 17 15.5 17 17.5C17 18.9422 15.5008 19.0001 14.5008 19.5001",
    stroke: "#2A2D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuddenBraking);
export default __webpack_public_path__ + "static/media/Icon_sudden_braking.8350b551038de3483601f363682b4dd3.svg";
export { ForwardRef as ReactComponent };